﻿module.exports = [
    'typeaheadsService', 
    cityTypeaheadFilter
];

function cityTypeaheadFilter(typeaheadsService) {
    return typeaheadsService.makePropertyTypeaheadFilter('CityName');
}